import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from "styled-components";
import { PrimaryButton } from '@shared/ui/atoms/buttons/PrimaryButton';
import DialogHeader from '@shared/dialogs/DialogHeader';
import Dialog from '@shared/ui/molecules/Dialog';
import { closeDialog } from "@shared/store/dialog.duck";
import TeamMultiSelect from '@shared/ui/organisms/team-drop-down-list/TeamMultiSelect';
import { selectAllTags } from "@shared/store/userTags.duck";
import { TeamEntity } from '@shared/models/team.models';
import { Tag } from '@shared/models/tags.models';
import { selectAllCheckedUsers } from "../ducks/manage-users.duck";
import { UserAvatarAndName } from '@shared/ui/molecules/UserAvatarAndName';
import { UserInfoV2 } from "../ducks/ManageUsers.model";
import { addMultipleUsersToWorkGroup } from '@shared/services/Tags';
import { Center } from '@shared/ui/atoms/StructuralLayout';
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import { failureNotification, successNotification } from "@shared/store/notification.duck";
import { loadConfig } from "@shared/store/config.duck";

export default function AssignToWorkGroupDialog(props: Props) {
  const dispatch = useDispatch();
  const workgroups = useSelector(selectAllTags);
  const [loading, setLoading] = useState(false);
  const [selection, setSelection] = useState<Tag | undefined>();
  const selectedUsers = useSelector(selectAllCheckedUsers);

  const close = () => {
    dispatch(closeDialog());
  }

  const onTeamSelect = (team: TeamEntity[], workGroup: Tag[]) => {
    if (workGroup.length > 0) {
      setSelection(workGroup[0]);
    }
  }

  const done = async () => {
    if (selection && selectedUsers.length > 0) {
      setLoading(true)
      try {
        await addMultipleUsersToWorkGroup(selectedUsers.map(u => u.id), selection.id);
        dispatch(loadConfig());
        dispatch(successNotification('Users added to workgroup'));
        close();
      } catch (e) {
        dispatch(failureNotification('Failed to add users to workgroup'));
      } finally {
        setLoading(false);
      }
    }
  }

  return (
    <DialogWrapper isOpen={true} onClose={close} showLogo={true}>
      <DialogHeader title="manage-users-page.assign-to-workgroup" />
      <TeamMultiSelect onSelect={onTeamSelect}
                       selectedWorkGroups={selection ? [selection] : []}
                       singleSelect={true}
                       workGroups={workgroups} />
      <UserList>
        {loading ? <Center><LoadingSpinner hideBorder={true} hideText={true}/></Center> : <>
          {selectedUsers.map((user: UserInfoV2, key: number) => <UserAvatarAndName key={key}
                                                                                   firstName={user.firstName}
                                                                                   lastName={user.lastName} />)}
        </>}
      </UserList>
      <PrimaryButton fullWidth={true} style={{marginBottom: 16, marginTop: 'auto'}} className={'saveChangesButton'} click={done} text="button.save-changes" />
    </DialogWrapper>
  )
}

interface Props {
  payload: any;
}

const DialogWrapper = styled(Dialog)<any>`
  &.dialog {
    max-width: 100%;
    min-height: 400px;
  }
  .dialog__contentContainer, .dialog__content {
    width: 300px;
    min-height: 410px;
  }
  .dialog__content {
    display: flex;
    flex-direction: column;
  }
  .saveChangesButton {
    margin-top: auto;
  }
`

const UserList = styled.div`
  height: 300px;
  margin: 16px 0;
  overflow-y: auto;
  .userAvatarAndName {
    margin-bottom: 8px;
  }
`
